import React from 'react';
import Icon from '../../../components/AppIcon';

const AvailabilityLegend = ({ className = '' }) => {
  const legendItems = [
    {
      status: 'available',
      label: 'در دسترس',
      color: 'bg-success/20 border-success/40',
      icon: 'Check',
      iconColor: 'text-success',
      description: 'کارمند آماده پذیرش مشتری است'
    },
    {
      status: 'busy',
      label: 'رزرو شده',
      color: 'bg-error/20 border-error/40',
      icon: 'X',
      iconColor: 'text-error',
      description: 'کارمند مشغول ارائه خدمات است'
    },
    {
      status: 'unavailable',
      label: 'غیرفعال',
      color: 'bg-muted border-border',
      icon: 'Minus',
      iconColor: 'text-muted-foreground',
      description: 'کارمند در این زمان حضور ندارد'
    },
    {
      status: 'mixed',
      label: 'ترکیبی',
      color: 'bg-warning/20 border-warning/40',
      icon: 'AlertTriangle',
      iconColor: 'text-warning',
      description: 'برخی کارمندان آزاد و برخی مشغول هستند'
    }
  ];

  return (
    <div className={`bg-card border border-border rounded-lg p-4 ${className}`}>
      <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
        <Icon name="Info" size={16} />
        راهنمای وضعیت‌ها
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {legendItems?.map((item) => (
          <div key={item?.status} className="flex items-start gap-3">
            <div className={`
              w-8 h-8 rounded border-2 flex items-center justify-center flex-shrink-0
              ${item?.color}
            `}>
              <Icon name={item?.icon} size={14} className={item?.iconColor} />
            </div>
            
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground">
                {item?.label}
              </h4>
              <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-border">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="MousePointer" size={14} />
          <span>برای تغییر وضعیت، روی هر خانه کلیک کنید</span>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityLegend;